import { useEffect, useRef } from 'react';

export interface IUseTimeoutProps {
  callback: () => void;
  delay: number | null;
}

function useTimeout({ callback, delay }: IUseTimeoutProps): void {
  const savedCallback = useRef<() => void>();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the timeout.
  useEffect(() => {
    function tick(): void {
      if (savedCallback?.current) {
        savedCallback.current();
      }
    }
    if (delay !== null) {
      let id = setTimeout(tick, delay);
      return () => clearTimeout(id);
    }
  }, [delay]);
}

export default useTimeout;
